









import { useRoute } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { isString } from 'lodash-es';
import { PropType } from 'vue';
import { useCustomerStore } from '~/modules/customer/stores/customer';
import { PageBuilderType } from '~/types/solepro/PageBuilder';
import { getComponent } from '~/utils/solepro/CmsComponentImport';
import { toggleExpandable } from '~/utils/solepro/PagebuilderBlockExpandable';
import { GenericObjectType } from '~/utils/types';

export default defineComponent({
  name: 'PageBuilderComponent',
  props: {
    node: {
      type: Object as PropType<PageBuilderType>,
      required: true,
    },
    customProps: {
      type: Object as PropType<GenericObjectType>,
      default: () => { return {} }
    }
  },
  setup(props) {
    const customerStore = useCustomerStore()
    const route = useRoute();
    const isPreviewPage = computed(()=>route.value.query.preview == 'true' /*&& customerStore.user?.hasPreview*/)
    const componentName = props.node.contentType;
    const component = getComponent(componentName, props.node.cssClasses);
    const componentExists = component !== 'div';
    const canShow = computed(()=> (!isPreviewPage.value && props.node.showOnline) || (isPreviewPage.value && props.node.showInPreview) )
    return {
      componentName,
      component,
      componentExists,
      canShow,
      isPreviewPage
    };
  },
  computed: {
    renderHTML() {
      if (process.server) {
        //@ts-ignore
        return isString(this.node.DOMContent) ? this.node.DOMContent : this.node.DOMContent.outerHTML;
      }

      //@ts-ignore
      return this.node.DOMContent;
    },
    hasChildren(): Boolean {
      const { children } = (this as any).node;
      return children && children.length > 0;
    },
  },
  mounted() {
    try {
      const targets = document.querySelectorAll('[data-target]') as unknown as HTMLElement[];
      targets.forEach(el => {
        if (el.tagName == 'A' && el.dataset.target != "")
          el.setAttribute('target', '_blank')
      })

    } catch (e) {
      console.warn('NOT QSA')
    }
    if (process.client) {
      const $component = this.$el;
      if (!$component.querySelectorAll) return;
      const expandable = $component.querySelector('.btn-read-more') as HTMLElement;
      if (!expandable) return;
      expandable.onclick = () => toggleExpandable(expandable)
    }
  }


});
